import colors from '../../../../../public/colors'


export default theme => {
    const { mode } = theme.palette
    const palette = colors[mode] || colors.light
    const isDark = mode === 'dark'

    return {
        card: {
            '@media screen and (min-width: 769px)': {
                height: '325px',
                padding: '24px',
                width: '650px'
            },
            alignItems: 'center',
            backgroundColor: isDark ? palette.cardContent : '#FFFFFF',
            border: isDark ? 'none' : '1px solid #E1E4E5',
            borderRadius: '0px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            height: 'auto',
            justifyContent: 'center',
            maxWidth: '100%',
            minHeight: '325px',
            padding: '32px 16px',
            textAlign: 'center',
            width: '100%'
        },
        button: {
            '&.MuiButton-root': {
                backgroundColor: '#FEDF01',
                borderRadius: '2px',
                boxShadow: 'none',
                color: '#000000',
                fontSize: '13px',
                fontWeight: 500,
                height: '36px',
                letterSpacing: '0.4px',
                marginTop: '24px',
                minWidth: '160px',
                width: 'fit-content',
                '&:hover': {
                    backgroundColor: '#e6ca00'
                }
            }
        },
        divider: {
            '&.MuiDivider-root': {
                marginTop: '24px',
                width: '100%'
            }
        },
        icon: {
            '&.MuiSvgIcon-root': {
                color: '#2E7D32',
                fontSize: '72px',
                marginBottom: '16px'
            }
        },
        pageWrapper: {
            '@media screen and (max-width: 768px)': {
                padding: theme.spacing(2, 1)
            },
            alignItems: 'center',
            boxSizing: 'border-box',
            display: 'flex',
            justifyContent: 'center',
            minHeight: '60vh',
            overflowX: 'hidden',
            padding: theme.spacing(4),
            width: '100%'
        },
        title: {
            '&.MuiTypography-root': {
                color: '#2E7D32',
                fontFamily: 'Roboto, sans-serif',
                fontSize: '24px',
                fontWeight: 400,
                letterSpacing: '-0.5px',
                lineHeight: '32px',
                marginBottom: '16px'
            }
        },
        verbiage: {
            '&.MuiTypography-root': {
                color: isDark ? palette.primaryText : '#60666D',
                fontFamily: 'Roboto, sans-serif',
                fontSize: '14px',
                fontWeight: 400,
                letterSpacing: '0.17px',
                lineHeight: '20px',
                whiteSpace: 'pre-line'
            }
        }
    }
}
